module.exports = __webpack_public_path__ + "img/588x310-02.c93f35f2.png";